import { HTMLAttributes } from "react";

interface OptimizedImageProps extends HTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  sizes?: string;
  priority?: boolean;
  width?: number;
  height?: number;
}

/**
 * OptimizedImage - A reusable component for optimized image loading
 * 
 * Features:
 * - Automatic webp source support via picture element
 * - Priority-aware eager/lazy loading
 * - Explicit dimensions to prevent CLS
 * - Decoding async for non-blocking parsing
 * - Lazy loading for below-fold images
 */
const OptimizedImage = ({
  src,
  alt,
  sizes = "100vw",
  priority = false,
  width,
  height,
  className,
  ...props
}: OptimizedImageProps) => {
  return (
    <picture>
      <source srcSet={src} type="image/webp" />
      <img
        src={src}
        alt={alt}
        className={className}
        loading={priority ? "eager" : "lazy"}
        decoding="async"
        sizes={sizes}
        width={width}
        height={height}
        {...props}
      />
    </picture>
  );
};

export default OptimizedImage;

